interface PortalTheme {
	id: string
	overridesTheme: boolean
	accentColor?: string | null
	darkModeAccentColor?: string | null
}

/** The selected portal's own accent, or null when it inherits the workspace accent the page already carries. */
export function portalAccentOverride({
	portalInstances,
	activePortalInstanceId,
	isDarkMode,
}: {
	portalInstances: readonly PortalTheme[]
	activePortalInstanceId: string | null
	isDarkMode: boolean
}): string | null {
	const portal = portalInstances.find((p) => p.id === activePortalInstanceId)
	if (!portal?.overridesTheme) return null
	return (isDarkMode ? portal.darkModeAccentColor : portal.accentColor) ?? null
}
